import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { ISalesFunnel } from '@user/store/salesFunnel'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'

type Props = {
  name: string
}

export function SalesFunnelSelect(props: Props) {
  const { name } = props
  const {
    getOptionLabel,
    options,
    initialOption,
    getId,
    isSubmitting,
    showError,
    helperText,
    density,
  } = useData({ name })
  const { handelChange } = useHandlers({ name })

  return (
    <Box>
      <Select<ISalesFunnel>
        density={density}
        disabled={isSubmitting}
        getLabel={getOptionLabel}
        getId={getId}
        error={showError}
        required
        items={options}
        onChange={handelChange}
        value={initialOption}
        label={'Sales Funnel'}
        optionMode={'normal'}
        testId="sales-funnel-select"
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  )
}
